<template>
  <div class="pt-2">
    <div class="rounded-xl shadow-nw px-4 py-3 mt-5" v-for="(order, index) in current_orders" :key="index">
      <div class="text-sm font-extrabold inline-block">
        Waybill #: <span class="uppercase">{{ firstFour(order.doc_id) }}</span>
      </div>
      <div class="text-sm font-extrabold inline-block float-right pt-px">&#8358;{{ order.payment_details.total }}</div>
      <div class="text-xs text-nw-ash">
        <date-created :created_at="order.pick_up.time_pick_up"></date-created>
      </div>
      <div v-if="clickedIndex == index">
        <div class="border-t border-gray-200 my-3"></div>
        <div class="flex">
          <div class="mt-3">
            <route-icon></route-icon>
          </div>
          <div class="px-4">
            <div class="text-xs text-nw-ash">Pick-up Location</div>
            <div class="text-xs font-extrabold pt-1">
              {{ order.pick_up.location }}
            </div>
            <div class="border-t border-gray-200 -mr-6 my-3"></div>
            <div class="text-xs text-nw-ash">Drop-off Location</div>
            <div class="text-xs font-extrabold pt-1">
              {{ order.delivering.location }}
            </div>
          </div>
        </div>
        <div class="border-t border-gray-200 my-3"></div>
        <div class="w-full">
          <div
            class="bg-green-600 hover:bg-green-700 text-xs inline-block text-white rounded-sm py-2 w-full text-center"
            v-if="order.attached != undefined"
            @click="openMap(true)"
          >
            View map
          </div>
          <!-- <div class="bg-purple-600 hover:bg-purple-700 text-xs inline-block text-white rounded-sm px-2 py-1">
            View details
          </div> -->
        </div>
        <view-map
          v-if="show_map"
          :from="order.pick_up.location"
          :to="order.delivering.location"
          :coordinates="order.delivering.coordinates"
          :driver_uid="order.driver_uid"
          v-on:open-map="openMap"
        ></view-map>
      </div>
      <div class="border-t border-gray-200 my-3 -mx-4"></div>
      <div class="text-xs font-semibold w-full" @click="expend(index)">
        <span class="text-purple-600" v-if="order.attached == undefined">Processing</span>
        <span v-else>
          <span
            class="text-nw-light-green"
            v-if="order.attached.picked_at == undefined && order.attached.attached_at != undefined"
            >Heading to pick-up</span
          >
          <span class="text-green-600" v-if="order.attached.picked_at != undefined">Heading to delivery</span>
        </span>
        <span class="float-right">
          <arrow-down-icon v-if="clickedIndex != index"></arrow-down-icon>
          <arrow-up-icon v-if="clickedIndex == index"></arrow-up-icon>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DateCreated from '../DateCreated.vue'
import ArrowDownIcon from '../icons/ArrowDownIcon.vue'
import ArrowUpIcon from '../icons/ArrowUpIcon.vue'
import RouteIcon from '../icons/RouteIcon.vue'
import ViewMap from './ViewMap.vue'
export default {
  components: { ArrowDownIcon, ArrowUpIcon, RouteIcon, DateCreated, ViewMap },
  data() {
    return {
      clickedIndex: null,
      show_map: false
    }
  },
  computed: {
    ...mapState('current_orders', ['current_orders'])
  },
  methods: {
    firstFour(string) {
      return string.substring(0, 6)
    },
    expend(index) {
      if (this.clickedIndex == index) {
        this.clickedIndex = null
      } else {
        this.clickedIndex = index
      }
    },
    openMap(val) {
      this.show_map = val
    }
  },
  mounted() {
    this.$store.dispatch('current_orders/currentOrders')
  }
}
</script>
